<template>
  <div class="Admin__PlannerRuns__Page" dir="rtl">
    <h1>ריצות לילה של התוכניות</h1>
    <b-table class="runs-table" :data="runs" :loading="isLoading" paginated backend-pagination pagination-simple :total="total"
      :per-page="perPage" :current-page="page" @page-change="onPageChange" :bordered="true" :hoverable="true"
      :selected="selectedRun" @click="selectRun" :row-class="(row) => getRunRowClass(row)">
      <b-table-column centered field="id" label="מזהה" v-slot="props">
        {{ props.row.id }}
      </b-table-column>
      <b-table-column centered field="startedAt" label="התחלה" v-slot="props">
        {{ formatDate(props.row.startedAt) }}
      </b-table-column>
      <b-table-column centered field="finishedAt" label="סיום" v-slot="props">
        {{ props.row.finishedAt ? formatDate(props.row.finishedAt) : 'לא הסתיימה' }}
      </b-table-column>
      <b-table-column centered field="totalCombos" label="סה״כ תלמידים בקורסים" v-slot="props">
        {{ props.row.totalCombos }}
      </b-table-column>
      <b-table-column centered field="succeededCount" label="הצליחו" v-slot="props">
        {{ props.row.succeededCount }}
      </b-table-column>
      <b-table-column centered field="failedCount" label="נכשלו" v-slot="props">
        {{ props.row.failedCount }}
      </b-table-column>
      <b-table-column centered field="status" label="סטטוס" v-slot="props">
        <b-tag v-if="!props.row.finishedAt" type="is-warning">לא הסתיימה</b-tag>
        <b-tag v-else-if="props.row.failedCount" type="is-danger">הסתיימה עם כשלים</b-tag>
        <b-tag v-else type="is-success">הצליחה</b-tag>
      </b-table-column>
      <template #empty>
        <div class="has-text-centered">אין ריצות להצגה</div>
      </template>
    </b-table>

    <div v-if="selectedRun" class="Admin__PlannerRuns__Page__Failures">
      <h2>כשלים בריצה {{ selectedRun.id }} ({{ formatDate(selectedRun.startedAt) }})</h2>
      <b-table :data="failures" :loading="isLoadingFailures" :bordered="true" :striped="true" detailed
        detail-key="id" :show-detail-icon="true">
        <b-table-column centered field="userId" label="מזהה תלמיד" v-slot="props">
          {{ props.row.userId }}
        </b-table-column>
        <b-table-column centered field="studentName" label="שם תלמיד" v-slot="props">
          {{ props.row.studentName }}
        </b-table-column>
        <b-table-column centered field="userName" label="שם משתמש" v-slot="props">
          {{ props.row.userName }}
        </b-table-column>
        <b-table-column centered field="courseName" label="קורס" v-slot="props">
          {{ props.row.courseId }} - {{ props.row.courseName }}
        </b-table-column>
        <b-table-column centered field="httpStatusCode" label="סטטוס HTTP" v-slot="props">
          {{ props.row.httpStatusCode }}
        </b-table-column>
        <b-table-column centered field="errorType" label="סוג שגיאה" v-slot="props">
          {{ props.row.errorType }}
        </b-table-column>
        <b-table-column field="errorMessage" label="הודעת שגיאה" v-slot="props">
          <div class="error-message-preview">{{ props.row.errorMessage }}</div>
        </b-table-column>
        <b-table-column centered field="failedAt" label="זמן" v-slot="props">
          {{ formatDate(props.row.failedAt) }}
        </b-table-column>
        <template #detail="props">
          <div class="error-message-full">{{ props.row.errorMessage }}</div>
        </template>
        <template #empty>
          <div class="has-text-centered">אין כשלים בריצה זו</div>
        </template>
      </b-table>
    </div>
  </div>
</template>

<script>
import moment from "moment";
import { ToastProgrammatic as Toast } from "buefy";
import AdminService from "@/services/AdminService";

export default {
  name: "AdminPlannerRuns",
  data() {
    return {
      isLoading: false,
      runs: [],
      total: 0,
      page: 1,
      perPage: 20,
      selectedRun: null,
      isLoadingFailures: false,
      failures: [],
    };
  },
  created() {
    this.getRuns();
  },
  methods: {
    getRuns() {
      this.isLoading = true;
      AdminService.getPlannerRuns({ PageNumber: this.page, PageSize: this.perPage })
        .then((r) => {
          this.runs = r.data.items;
          this.total = r.data.totalResults;
        })
        .catch((error) => this.showError(error, "שגיאה בטעינת הריצות"))
        .finally(() => {
          this.isLoading = false;
        });
    },
    onPageChange(page) {
      this.page = page;
      this.getRuns();
    },
    selectRun(run) {
      this.selectedRun = run;
      this.failures = [];
      this.isLoadingFailures = true;
      AdminService.getPlannerRunFailures(run.id)
        .then((r) => {
          if (this.selectedRun === run) this.failures = r.data;
        })
        .catch((error) => this.showError(error, "שגיאה בטעינת הכשלים"))
        .finally(() => {
          this.isLoadingFailures = false;
        });
    },
    getRunRowClass(row) {
      if (!row.finishedAt) return "unfinished-row";
      return row.failedCount ? "failed-row" : "";
    },
    formatDate(date) {
      return moment(date).format("DD/MM/YYYY HH:mm");
    },
    showError(error, fallbackMessage) {
      const data = error.response && error.response.data;
      Toast.open({
        type: "is-danger",
        message: typeof data === "string" && data ? data : fallbackMessage,
        duration: 5000,
      });
    },
  },
};
</script>

<style scoped lang="scss">
.Admin__PlannerRuns__Page {
  padding: 20px 40px;

  h1 {
    font-size: 30px;
    border-bottom: 1px solid silver;
    padding: 0 10px 10px 10px;
    margin-bottom: 20px;
  }

  h2 {
    font-size: 22px;
    margin: 30px 0 10px 0;
  }

  ::v-deep {
    .unfinished-row {
      background-color: #fff6da;
    }

    .failed-row {
      background-color: #ffdada;
    }

    .runs-table tbody tr {
      cursor: pointer;
    }

    .pagination.is-simple {
      flex-direction: row-reverse;
    }
  }

  .error-message-preview {
    max-width: 400px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .error-message-full {
    white-space: pre-wrap;
    word-break: break-word;
    unicode-bidi: plaintext;
    text-align: start;
  }
}
</style>
